import { createSelector } from '@reduxjs/toolkit'

const getApiBusinessDetail = (state: any) => state.apiBusinessDetail

export const apiBusinessDetailSelector = createSelector(getApiBusinessDetail, (apiBusinessDetail) => apiBusinessDetail)
